import { AccountTypes } from '@shared/utils/base-auth';

export class VerificationCodeRequest {
  constructor(public PhoneNumber: string) {}
}

export class RegisterGuestRequest {
  constructor(
    public FirstName: string,
    public LastName: string,
    public TimeZone: string,
    public Password: string,
    public PhoneNumber: string,
    public AccountType: AccountTypes,
    public VerificationCode: string = ''
  ) {}
}

export class NotificationBannerReadRequest {
  constructor(public IsNotificationBannerRead: boolean) {}
}
